<template>
  <div class="notifications">
    <div v-for="message in sortByDateMessages.slice(0, this.maxNotifications)" v-if="message.show" :key="message.id" class="alert" :class="`alert-${message.type}`" role="alert">
      <span class="close" @click="closeNotification(message.id)">
        ×
      </span>
      <strong v-if="message.message.title">{{ message.message.title }}:</strong> <span class="notifications__message">{{ message.message.body }}</span>
    </div>
  </div>
</template>

<script>
import {sort} from 'ramda'
import {notificationMixin} from '@/mixins/notificationMixin'
export default {
  name: 'Notifications',
  mixins: [notificationMixin],
  props: {
    messages: {
      type: Array
    }
  },
  data: () => ({
    maxNotifications: 1
  }),
  computed: {
    sortByDateMessages () {
      const dateCompare = (a, b) => b.date - a.date
      return sort(dateCompare, this.messages)
    }
  },
  methods: {
    closeNotification (id) {
      this.closeLastNotification(id)
    }
  }
}
</script>

<style lang="scss">
    .notifications {
      &__message {
        white-space: pre-wrap;
        word-wrap: break-word;
        font-family: inherit;
      }
      & .alert{
        border-radius: 0;
      }
    }
</style>



// WEBPACK FOOTER //
// src/components/Notifications/notifications.vue